module.exports = __webpack_public_path__ + "static/media/9.f2f2f43f.jpg";